import React, { FC } from 'react';
import { useSelector } from 'react-redux';
import { deepEqual } from 'fast-equals';
import { OverlayView } from '@react-google-maps/api';

import { mapSpotMarkerSelector } from '../../slices/mapSpotSlice';
import { AppState, MarkerType } from '../../types';
import MapSpotMarker from './mapSpotMarkerComponent';

// Mapに関してはWrapperの子componentとして外部で指定しないと上手く表示されない。
// 原因はわかりませんが、本家の例も同様の記載方法。useRefが影響していると思います。

const MapSpotMarkers: FC = () => {
  // useSelector の比較ロジックは状態の「更新」が発生した場合にのみ、再レンダリングが発生する
  // 更新が発生したかどうかの判定には、SameValueではなく[===]が利用されるため、
  // 更新が発生したかどうかチェックする対象は「セレクタの返り値」であり、それは必ずしもstateとは限らない。
  // === で比較する場合、オブジェクト、配列は値ではなく参照先が同じかの判定になるため、毎回 falseとなり再レンダリングが発生する
  // deepEqualを利用して、ネストしているspotオブジェクトの値を比較できるようにしている
  const mapSpotMarkers = useSelector((state: AppState) => mapSpotMarkerSelector(state), deepEqual);

  return (
    <>
      {mapSpotMarkers.map((marker: MarkerType | undefined) => {
        if (marker) {
          return (
            <OverlayView
              key={Math.random()}
              position={{ lat: marker.lat, lng: marker.lng }}
              mapPaneName={OverlayView.OVERLAY_MOUSE_TARGET}
            >
              <MapSpotMarker mapSpotMarker={marker} />
            </OverlayView>
          );
        }
        return null;
      })}
    </>
  );
};

export default React.memo(MapSpotMarkers);
